import { Button, Link, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from "@heroui/react";
import { ChevronRightCircleIcon } from "lucide-react";
import DividerDark from "../assets/divider-dark.svg";
import { EvmWalletList } from "./ConnectWallets";

export default function ConnectEthWalletModal() {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  return (
    <>
      <Button
        fullWidth
        size="lg"
        endContent={<ChevronRightCircleIcon />}
        className="flex justify-between bg-[var(--turnstile-content-bg-color)]"
        onPress={onOpen}
      >
        Connect Ethereum Wallet
      </Button>
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        backdrop="blur"
        classNames={{ base: "turnstile-modal-border" }}
      >
        <ModalContent>
          <ModalHeader>Connect your wallet</ModalHeader>

          <img src={DividerDark} alt="Divider" className="w-full" />

          <ModalBody>
            <EvmWalletList />
          </ModalBody>

          <ModalFooter>
            <p className="text-center">
              By connecting your wallet, you agree to our
              <Link href="#">Terms of Service</Link> and <Link href="#">Privacy Policy</Link>.
            </p>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
